import * as React from 'react';
import { IconImageColorFilterProps } from '../IconImage';
import IconButton from '../IconButton';
import { getBasePath } from '../../../utils/browser';

interface IconButtonProps {
  readonly onClick?: () => void;
  readonly imagePath: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly containerStyle?: React.CSSProperties;
  readonly imageStyle?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
  readonly colorFilter?: IconImageColorFilterProps;
}

const buttonStyle: React.CSSProperties = {
  width: '122px',
  height: '52px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  justifyContent: 'center',
  color: 'inherit',
  textDecoration: 'none',
  background: 'rgba(0, 0, 0, 0.1)',
  boxSizing: 'border-box',
  overflow: 'hidden',
  top: '4px',
  left: '4px',
};

const buttonContainerStyle: React.CSSProperties = {
  height: '130px',
  width: '60px',
  boxSizing: 'border-box',
};

const frameImageStyle: React.CSSProperties = {
  position: 'relative',
  width: '130px',
  height: '60px',
  top: '-52px',
  pointerEvents: 'none',
};

const imageBaseStyle: React.CSSProperties = {
  width: '122px',
  height: '52px',
};

const SelectableBigRectangleIconButton: React.SFC<IconButtonProps> = React.memo((props) => {
  const {
    imagePath, style, imageStyle, svgStyle, active, disabled, margin, colorFilter, containerStyle,
    onClick, title, href, ariaLabel,
  } = props;

  const buttonContainerAdditionalStyle: React.CSSProperties = {};
  const frameImageAdditionalStyle: React.CSSProperties = {};

  const baseDir = getBasePath();
  const imgSrc = `${baseDir}/images/setting-popup/frame/select_frame_bw_color_01.png`;

  if (margin !== false) {
    buttonContainerAdditionalStyle.margin = '5px';
  }

  frameImageAdditionalStyle.visibility = active ? 'visible' : 'hidden';

  return (
    <div style={{ ...buttonContainerStyle, ...buttonContainerAdditionalStyle, ...containerStyle }}>
      <IconButton
        onClick={onClick}
        imagePath={imagePath}
        margin={false}
        active={false}
        style={{ ...buttonStyle, ...style }}
        imageStyle={{ ...imageBaseStyle, ...imageStyle }}
        svgStyle={{ ...imageBaseStyle, ...svgStyle }}
        disabled={disabled}
        colorFilter={colorFilter}
        title={title}
        href={href}
        ariaLabel={ariaLabel}
      />
      <img src={imgSrc} style={{ ...frameImageStyle, ...frameImageAdditionalStyle }} />
    </div>
  );
});

export default SelectableBigRectangleIconButton;
